import * as React from 'react'
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
} from '@mui/material'
import { PERMISSION_OPTIONS } from './columns'

// Flags guardados de la asignación; solo cuenta `=== true` (si falta el dato, queda desmarcado).
const getStoredPermissions = assignment =>
  Object.fromEntries(
    PERMISSION_OPTIONS.map(({ permission }) => [permission, assignment?.[permission] === true]),
  )

/**
 * Edición de los permisos (registrar / actualizar) de una asignación usuario↔tenant.
 * Controlado por el padre: `onSave({ canRegister, canUpdate })` guarda y `onCancel` cierra.
 */
const EditPermissionsDialog = ({ open, assignment, saving, onCancel, onSave }) => {
  const [permissions, setPermissions] = React.useState(() => getStoredPermissions(assignment))

  // Cada apertura parte de los valores guardados de la asignación.
  React.useEffect(() => {
    if (open) setPermissions(getStoredPermissions(assignment))
  }, [open, assignment])

  const storedPermissions = getStoredPermissions(assignment)
  const hasChanges = PERMISSION_OPTIONS.some(
    ({ permission }) => permissions[permission] !== storedPermissions[permission],
  )

  const handlePermissionChange = permission => event =>
    setPermissions(current => ({ ...current, [permission]: event.target.checked }))

  const handleClose = () => {
    if (saving) return
    onCancel()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="edit-permissions-dialog-title"
    >
      <DialogTitle id="edit-permissions-dialog-title">Editar permisos</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Tenant: <strong>{assignment?.tenantName}</strong>
        </DialogContentText>
        <FormGroup sx={{ mt: 1 }}>
          {PERMISSION_OPTIONS.map(({ permission, label }) => (
            <FormControlLabel
              key={permission}
              control={
                <Checkbox
                  checked={permissions[permission]}
                  onChange={handlePermissionChange(permission)}
                  disabled={saving}
                  size="small"
                />
              }
              label={label}
            />
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={() => onSave(permissions)}
          disabled={saving || !hasChanges}
        >
          {saving ? 'Guardando…' : 'Guardar'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditPermissionsDialog
